import React from 'react';

import KPTable from '../../../../components/KPTComponents/KPTable';

import { ActionColumn } from '../../../../containers/DangKyHoSo/utils';
import { RESEARCH_PROJECT_MODEL, CRUD_MODELS } from '../../../../constants';

function DeTaiTable({ rows, setDialog, ...props }) {
  const columns = [
    { ...RESEARCH_PROJECT_MODEL.title, width: '40%' },
    {
      ...RESEARCH_PROJECT_MODEL.role,
      width: '20%',
      filters: RESEARCH_PROJECT_MODEL.role.options,
      render: (value) => RESEARCH_PROJECT_MODEL.role.options.find((e) => e.value === value)?.title,
      onFilter: (value, row) => row.role === value,
    },
    { ...RESEARCH_PROJECT_MODEL.assessmentAgency, width: '20%' },
    {
      key: 'link',
      label: 'Tác vụ',
      width: '20%',
      render: (_, row) => (
        <ActionColumn
          row={row}
          type={CRUD_MODELS.RESEARCH_PROJECT}
          setDialog={setDialog}
          setPreview={props.setPreview}
          setDeleteCrud={props.setDeleteCrud}
        />
      )
    }
  ];

  return (
    <KPTable
      columns={columns}
      nonBorder={!!props.nonBorder}
      rows={rows}
      // loading={loading}
    />
  );
}

export default DeTaiTable;
